export const get_hotel_req="get_hotel_req";
export const get_hotel_success="get_hotel_success";
export const get_hotel_fail="get_hotel_fail";


